import React from 'react';
import { motion } from 'framer-motion';
import { TelegramNotification } from '../types';

interface Props {
  notifications: TelegramNotification[];
}

const typeStyles: Record<string, { icon: string; color: string }> = {
  task_start: { icon: '🚀', color: '#3b82f6' },
  task_complete: { icon: '✅', color: '#22c55e' },
  error: { icon: '🔴', color: '#ef4444' },
  commit: { icon: '📦', color: '#8b5cf6' },
  pr_created: { icon: '🔀', color: '#f59e0b' },
};

export const TelegramFeed: React.FC<Props> = ({ notifications }) => {
  return (
    <div className="telegram-feed">
      <div className="feed-header">
        <span className="feed-icon">📱</span>
        <h3>Telegram Feed</h3>
        <span className="feed-badge">{notifications.length}</span>
      </div>
      <div className="feed-list">
        {notifications.map((n, i) => {
          const style = typeStyles[n.type] || typeStyles.task_start;
          return (
            <motion.div
              key={n.id}
              className="feed-item"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: i * 0.05 }}
            >
              <span className="feed-item-icon">{style.icon}</span>
              <div className="feed-item-content">
                <div className="feed-item-header">
                  <span className="feed-item-worker" style={{ color: style.color }}>
                    {n.worker}
                  </span>
                  <span className="feed-item-time">{n.timestamp}</span>
                </div>
                <div className="feed-item-msg">{n.message}</div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};
